import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the AsociacionesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-asociaciones',
  templateUrl: 'asociaciones.html',
})
export class AsociacionesPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AsociacionesPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/asociaciones/asociaciones.ts